export default async (polygon?: string) => {

  const { data } = await useFetch('/api/species/' + polygon)

  return { data }
}
